<template>
  <div>
    <dl>
      <dt v-b-toggle="'collapse-ranking' + index" @click="registerStatistics()"><span class="mr-2" style="color: #076cb9;font-size: 1.5rem;">{{ index + 1 }}.</span>{{this.question}}</dt>
      <b-collapse :id="'collapse-ranking' + index">
          <dd v-html="this.answer"></dd>
          <dd class="LeadText" v-if="this.text">＜{{this.text}}＞</dd>
          <dd class="LinkURL" v-if="this.url"><a v-bind:href="this.url" target="_blank">{{this.url}}</a></dd>
      </b-collapse>
    </dl>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    props: ["index", "question", "answer", "text", "url"],
    name: "QaBoxRanking",
    methods: {
        ...mapActions(['statistics']),
        registerStatistics() {
            if (!this.isOpen) {
                this.statistics({type: 3, value: this.question});
                this.isOpen = true;
            } else {
                this.isOpen = false;
            }
        }
    },
};
</script>
<style scoped>
@media screen and (max-width: 510px) {
    dd >>> img {
        width: 100%;
    }
}
dd {
    white-space: pre-wrap
}

.qa_box dl {
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    margin-bottom: 5px;
}

.qa_box dl dt {
    font-size: 14px;
    font-weight: bold;
    background: #fafdff;
    padding: 20px;
    border-radius: 10px;
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
}

.qa_box dl dd {
    font-size: 14px;
    padding: 20px;
}

.qa_box dl dd.LeadText {
    padding-bottom: 0px;
}

.qa_box dl dd.LinkURL {
    padding-top: 0px;
    word-break: break-all;
}
</style>
